import columns from '../../../../react-table/helpers/columns';

export default (data, assetType) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeColumn,
    FilteredDateColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Outbound Operator', 'operatorFrom'),
        new FilteredTextColumn('Outbound IMPC', 'impcFrom'),
        new FilteredTextColumn('Inbound Operator', 'operatorTo'),
        new FilteredTextColumn('Inbound IMPC', 'impcTo'),
        new FilteredDateTimeColumn('When', 'when').withWidth(140),
        new FilteredTextColumn('Priority', 'priority'),
        new FilteredTextColumn('Transfer Operators', 'transferOperators').withShow(assetType === 'pallet'),
        new FilteredTextColumn('Transfer IMPCs', 'transferLocations').withShow(assetType === 'pallet'),
        new FilteredDateTimeColumn('Route Start Date', 'routeStartDate').withWidth(140),
        new FilteredDateTimeColumn('Route End Date', 'routeEndDate').withWidth(140),
        new FilteredTextColumn('User', 'user'),
        new FilteredNonZeroNumberColumn('ID', 'id'),
        new FilteredTextColumn('Comments', 'comments'),
        new FilteredDateColumn('Exceptional LC Start date', 'exceptionalLCStartDate').withShow(assetType === 'pallet'),
        new FilteredDateColumn('Exceptional LC Stop date', 'exceptionalLCEndDate').withShow(assetType === 'pallet'),
      ],
    },
  ];
};
